import { CssBaseline, ThemeProvider } from "@mui/material";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { queryClient } from "@/app/queryClient";
import { router } from "@/app/router";
import { createAppTheme } from "@/app/theme";
import { useThemeStore } from "@/stores/useThemeStore";

/**
 * Providers: theme, server state, and routing.
 */

export const App = () => {
    const mode = useThemeStore((state) => state.mode);

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={createAppTheme(mode)}>
                <CssBaseline />
                <RouterProvider router={router} />
            </ThemeProvider>
        </QueryClientProvider>
    );
};
